import React, { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import { Footer, NavBar } from '../components';

const AppLayout: React.FC = (): ReactElement => (
  <div className="main_container app_shell">
    <NavBar />
    <main className="page-body app_content">
      <div className="page_route">
        <Outlet />
      </div>
    </main>
    <Footer />
  </div>
);

export default AppLayout;
